<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>Filters</h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col cols="12" md="3" class="mb-2">
          <label>Role</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="roleFilter"
            :options="roleOptions"
            class="w-100"
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:roleFilter', val)"
          />
        </b-col>
        <b-col cols="12" md="3" class="mb-2">
          <label>User Type</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="typeFilter"
            class="w-100"
            :options="typeOptions"
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:typeFilter', val)"
          />
        </b-col>
        <b-col cols="12" md="3" class="mb-2">
          <label>Partner Assigned</label>
          <v-select
            :options="partnerOptions"
            :value="isPartnerAssigned"
            class="w-100"
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:isPartnerAssigned', val)"
          />
        </b-col>
        <b-col cols="12" md="3" class="mb-2">
          <label>Status</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="statusFilter"
            :options="statusOptions"
            class="w-100"
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:statusFilter', val)"
          />
        </b-col>
        <b-col cols="23" md="3" class="mb-2">
          <label>Reward Activated?</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="rewardActivatedFilter"
            :options="rewardActivatedOptions"
            class="w-100"
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:rewardActivatedFilter', val)"
          />
        </b-col>
        <b-col cols="23" md="3" class="mb-2">
          <label>Trx Hash Submitted?</label>
          <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :value="hashSubmittedFilter"
            :options="hashSubmittedOptions"
            class="w-100"
            :reduce="(val) => val.value"
            @input="(val) => $emit('update:hashSubmittedFilter', val)"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol } from "bootstrap-vue";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  props: {
    roleFilter: {
      type: [String, null],
      default: null,
    },
    typeFilter: {
      type: [String, null],
      default: null,
    },
    typeOptions: {
      type: Array,
      default: null,
    },
    statusFilter: {
      type: [String, null],
      default: null,
    },
    rewardActivatedFilter: {
      type: [String, null],
      default: null,
    },
    hashSubmittedFilter: {
      type: [String, null],
      default: null,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    rewardActivatedOptions: {
      type: Array,
      required: true,
    },

    hashSubmittedOptions: {
      type: Array,
      required: true,
    },

    partnerOptions: {
      type: Array,
      required: true,
    },
    isPartnerAssigned: {
      type: [Boolean, null],
      default: null,
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
